export const getExternalSource = (dataSource) => {
    if (dataSource === 'google_analytics') {
        return 'googleAnalytics';
    }
};
